<template>
    <el-dialog title="支付类型维护" :visible="visible" :show="show" width="45%"
               :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="支付标题" class="input" prop="payTitle">
                <el-input v-model="ruleForm.payTitle" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="有效期天数" class="input" prop="days">
                <el-input v-model.number="ruleForm.days" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="原价" class="input" prop="originalMoney">
                <el-input v-model.number="ruleForm.originalMoney" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="支付金额" class="input" prop="money">
                <el-input v-model.number="ruleForm.money" autocomplete="off" placeholder="请输入..."></el-input>
            </el-form-item>

            <el-form-item label="是否启用" class="input" prop="disabled">
                <el-radio v-model="ruleForm.disabled" label="0">禁用</el-radio>
                <el-radio v-model="ruleForm.disabled" label="1">启用</el-radio>
            </el-form-item>


            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                visible:false,
                ruleForm:{
                    payTitle:'',
                    days:'',
                    money:'',
                    diabled:'',
                    originalMoney:'',
                },
                rules:{
                    payTitle:[{ required: true, message: '请输入支付标题', trigger: 'blur' }],
                    days:[{ required: true, message: '请输入有效期天数', trigger: 'blur' }],
                    money:[{ required: true, message: '请输入折扣价格', trigger: 'blur' }],
                    diabled:[{ required: true, message: '请输入是否启用', trigger: 'blur' }],
                    originalMoney:[{ required: true, message: '请输入原价', trigger: 'blur' }],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`payType/`+"save":this.url+`payType/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            // 上传文件成功后执行
            handleUploadSuccess(res, file, fileList) {
                this.ruleForm.img = file.response.file;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多上传${this.limit}张图片`);
            },

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>